import React from 'react'
import { ListInvoice } from 'dealer-types'
import { ItemProvider } from 'src/contexts/itemContext'
import InvoiceItem from '../molecules/InvoiceItem'
const InvoiceItemWrapper = (props: ListInvoice): JSX.Element => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
    // @ts-ignore
    <ItemProvider {...props}>
      <InvoiceItem />
    </ItemProvider>
  )
}

export default InvoiceItemWrapper
